import { makeVar } from '@apollo/client';

export const availableFeatureFlagsVar = makeVar<string[]>([]);
